/*
 * MTO Product List — Web Component v2
 * Handles: carousel navigation, video hover, last-viewed tracking/fetch,
 *          related/complementary lazy-load, quick-add
 */

/* ====== CUSTOM ELEMENT ====== */
if (!customElements.get('mto-product-list')) {
  class MtoProductList extends HTMLElement {
    connectedCallback() {
      this.source = this.dataset.source;
      this.track = this.querySelector('.mto-pl__track');
      this.navPrev = this.querySelector('.mto-pl__nav-btn--prev');
      this.navNext = this.querySelector('.mto-pl__nav-btn--next');

      if (this.source === 'collection') {
        this.onReady();
      } else {
        this.observeIntersection();
      }
    }

    observeIntersection() {
      var self = this;
      this.observer = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          self.observer.unobserve(self);
          self.loadProducts();
        },
        { rootMargin: '0px 0px 200px 0px' }
      );
      this.observer.observe(this);
    }

    loadProducts() {
      if (this.source === 'last_viewed') {
        this.loadLastViewed();
      } else if (this.source === 'related' || this.source === 'complementary') {
        this.loadRecommendations();
      }
    }

    /* ---- Recommendations (Related / Complementary) ---- */
    loadRecommendations() {
      var self = this;
      var productId = this.dataset.productId;
      if (!productId) { this.hideSection(); return; }

      var limit = this.dataset.productCount || 8;
      var url = this.dataset.recommendationsUrl +
        '?product_id=' + productId +
        '&limit=' + limit +
        '&section_id=' + this.dataset.sectionId;

      if (this.source === 'complementary') {
        url += '&intent=complementary';
      }

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var remote = doc.querySelector('mto-product-list');
          if (remote && remote.querySelector('.mto-pl__card')) {
            self.innerHTML = remote.innerHTML;
            self.track = self.querySelector('.mto-pl__track');
            self.navPrev = self.querySelector('.mto-pl__nav-btn--prev');
            self.navNext = self.querySelector('.mto-pl__nav-btn--next');
            self.onReady();
          } else {
            self.hideSection();
          }
        })
        .catch(function () { self.hideSection(); });
    }

    /* ---- Last Viewed ---- */
    loadLastViewed() {
      var self = this;
      var raw = [];
      try {
        raw = JSON.parse(localStorage.getItem('mto-last-viewed') || '[]');
      } catch (e) {}

      // Normalize: migrate old string entries to { handle, variantId }
      var items = raw.map(function (x) {
        return typeof x === 'string' ? { handle: x, variantId: null } : x;
      });

      // Exclude current product
      var currentHandle = this.dataset.currentProductHandle;
      if (currentHandle) {
        items = items.filter(function (x) { return x.handle !== currentHandle; });
      }

      var showVariantsSeparate = this.dataset.showVariantsSeparate === 'true';

      // Deduplicate
      if (showVariantsSeparate) {
        var seen = {};
        items = items.filter(function (x) {
          var k = x.handle + ':' + (x.variantId || '');
          if (seen[k]) return false;
          seen[k] = true;
          return true;
        });
      } else {
        var seenH = {};
        items = items.filter(function (x) {
          if (seenH[x.handle]) return false;
          seenH[x.handle] = true;
          return true;
        });
      }

      var max = parseInt(this.dataset.productCount, 10) || 8;
      items = items.slice(0, max);

      if (items.length === 0) { this.hideSection(); return; }

      // Collect unique handles to fetch
      var uniqueHandles = {};
      items.forEach(function (x) { uniqueHandles[x.handle] = true; });

      var handles = Object.keys(uniqueHandles);

      var productRequests = handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) {
            if (!r.ok) throw new Error(r.status);
            return r.json();
          })
          .catch(function () { return null; });
      });

      var birimRequests = handles.map(function (handle) {
        return fetch('/products/' + handle + '?section_id=product-meta-birim')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            return tmp.textContent.trim();
          })
          .catch(function () { return ''; });
      });

      Promise.all([Promise.all(productRequests), Promise.all(birimRequests)]).then(function (results) {
        var products = results[0];
        var birims = results[1];
        var productMap = {};
        var birimMap = {};
        products.filter(Boolean).forEach(function (p) { productMap[p.handle] = p; });
        handles.forEach(function (h, i) { birimMap[h] = birims[i] || ''; });

        if (Object.keys(productMap).length === 0) { self.hideSection(); return; }

        self._birimMap = birimMap;
        self.renderLastViewedCards(items, productMap);
        self.onReady();
      }).catch(function (err) {
        console.error('[MTO Product List] last_viewed error:', err);
      });
    }

    renderLastViewedCards(items, productMap) {
      var template = this.querySelector('template');
      if (!template) return;

      var showVariantsSeparate = this.dataset.showVariantsSeparate === 'true';
      var variantOptionName = (this.dataset.variantOptionName || '').toLowerCase();
      var quickAdd = this.dataset.quickAdd === 'true';
      var addToCartText = this.dataset.addToCartText || 'Add to Cart';
      var currencyCode = this.dataset.currencyCode === 'true';
      var showSecondImage = this.dataset.showSecondImage === 'true';
      var hideSoldOut = this.dataset.hideSoldOut === 'true';

      var frag = document.createDocumentFragment();
      var self = this;

      // Tema ayarı: tükenen ürünler listenin sonuna (stabil sıralama)
      if (this.dataset.soldOutLast === 'true') {
        var inStock = [];
        var soldOut = [];
        items.forEach(function (item) {
          var p = productMap[item.handle];
          var avail = p ? p.available : true;
          if (p && showVariantsSeparate && item.variantId) {
            for (var vi = 0; vi < (p.variants || []).length; vi++) {
              if (p.variants[vi].id === item.variantId) {
                avail = p.variants[vi].available;
                break;
              }
            }
          }
          (avail ? inStock : soldOut).push(item);
        });
        items = inStock.concat(soldOut);
      }

      items.forEach(function (item) {
        var product = productMap[item.handle];
        if (!product) return;

        if (showVariantsSeparate) {
          // Find the specific tracked variant
          var variant = null;
          if (item.variantId) {
            for (var i = 0; i < (product.variants || []).length; i++) {
              if (product.variants[i].id === item.variantId) {
                variant = product.variants[i];
                break;
              }
            }
          }
          if (!variant) variant = self.getDefaultVariant(product);
          if (!variant) return;

          if (hideSoldOut && !variant.available) return;

          // Resolve variant label from the option name
          var variantLabel = null;
          if (variantOptionName) {
            var optionIndex = -1;
            (product.options || []).forEach(function (opt, i) {
              var name = typeof opt === 'string' ? opt : (opt.name || '');
              if (name.toLowerCase() === variantOptionName) optionIndex = i;
            });
            if (optionIndex > -1) variantLabel = variant.options[optionIndex];
          }

          frag.appendChild(
            self.buildCard(template, product, variant, variantLabel, quickAdd, addToCartText, currencyCode, showSecondImage)
          );
        } else {
          if (hideSoldOut && !product.available) return;

          var variant = self.getDefaultVariant(product);
          frag.appendChild(
            self.buildCard(template, product, variant, null, quickAdd, addToCartText, currencyCode, showSecondImage)
          );
        }
      });

      this.track.innerHTML = '';
      this.track.appendChild(frag);
    }

    buildCard(template, product, variant, variantLabel, quickAdd, addToCartText, currencyCode, showSecondImage) {
      var self = this;
      var clone = template.content.cloneNode(true);
      var card = clone.querySelector('.mto-pl__card');
      var link = clone.querySelector('.mto-pl__card-link');
      var img = clone.querySelector('.mto-pl__media-primary');
      var titleEl = clone.querySelector('.mto-pl__title');
      var priceEl = clone.querySelector('.mto-pl__price');
      var mediaContainer = clone.querySelector('.mto-pl__media');

      // URL
      var url = '/products/' + product.handle;
      if (variant && variant.id) url += '?variant=' + variant.id;
      if (link) link.href = url;

      // Image
      var image = (variant && variant.featured_image && variant.featured_image.src)
        ? variant.featured_image.src
        : (product.featured_image || '');

      if (img && image) {
        img.srcset = [165, 360, 533, 720, 940, 1066].map(function (w) {
          return self.resizeImage(image, w) + ' ' + w + 'w';
        }).join(', ');
        img.src = self.resizeImage(image, 533);
        img.alt = product.title;
        img.width = 533;
        img.height = 533;
      }

      // Second image
      if (showSecondImage && product.images && product.images.length > 1) {
        var secondSrc = product.images[1];
        if (secondSrc && mediaContainer) {
          var secondImg = document.createElement('img');
          secondImg.className = 'mto-pl__media-hover';
          secondImg.loading = 'lazy';
          secondImg.alt = '';
          secondImg.srcset = [165, 360, 533, 720].map(function (w) {
            return self.resizeImage(secondSrc, w) + ' ' + w + 'w';
          }).join(', ');
          secondImg.src = self.resizeImage(secondSrc, 533);
          mediaContainer.appendChild(secondImg);
        }
      }

      // Adapt ratio
      if (this.dataset.imageRatio === 'adapt' && image) {
        // For JS cards we can't know aspect ratio before loading, use square fallback
        // or read from Shopify image URL params if available
      }

      // Title — metin ANCHOR'a yazılır. titleEl (h3) içine yazmak, içindeki
      // .mto-pl__card-link anchor'ını siler (kart tıklanamaz hale gelirdi).
      if (link) {
        link.textContent = product.title;
      } else if (titleEl) {
        titleEl.textContent = product.title;
      }

      // Variant label
      var variantLabelEl = clone.querySelector('.mto-pl__variant-label');
      if (variantLabelEl) {
        if (variantLabel) {
          variantLabelEl.textContent = variantLabel;
          variantLabelEl.removeAttribute('hidden');
        } else {
          variantLabelEl.setAttribute('hidden', '');
        }
      }

      // Sold-out badge (tema ayarı)
      if (this.dataset.showSoldOutBadge === 'true' && mediaContainer) {
        var cardAvailable = variant ? variant.available : product.available;
        if (!cardAvailable) {
          var soldOutBadge = document.createElement('span');
          soldOutBadge.className = 'mto-pl__badge';
          soldOutBadge.textContent = this.dataset.soldOutText || 'Tükendi';
          mediaContainer.appendChild(soldOutBadge);
        }
      }

      // Ölçü rozeti + paneli (varyant ayrıştırılmamış kartlarda, tema ayarı).
      // İskelet template'te Liquid tarafından basılı (SVG + çeviriler orada);
      // burada YALNIZ veri doldurulur. Liquid'deki mto-size-options.liquid ile
      // aynı kuralları uygular — ikisi ayrışırsa slider ve koleksiyon kartları
      // farklı şey söyler.
      if (this.dataset.showSizeChips === 'true' && !variantLabel) {
        this.fillSizeOptions(clone, product, currencyCode);
      } else {
        var sizeWrapOff = clone.querySelector('[data-mto-size]');
        if (sizeWrapOff) sizeWrapOff.remove();
      }

      // Price
      if (priceEl) {
        var price = variant ? variant.price : product.price;
        var comparePrice = variant ? variant.compare_at_price : product.compare_at_price;
        var birim = this._birimMap && product.handle ? this._birimMap[product.handle] : '';
        var priceLabel = birim || this.dataset.priceLabel || '';
        if (priceLabel && priceLabel.charAt(0) !== '/') priceLabel = '/ ' + priceLabel;
        var priceHTML = '';
        if (comparePrice && comparePrice > price) {
          priceHTML += '<s class="mto-pl__price-compare">' + this.formatMoney(comparePrice, currencyCode) + '</s>';
        }
        priceHTML += '<span class="mto-pl__price-current">' + this.formatMoney(price, currencyCode) + '</span>';
        if (priceLabel) {
          priceHTML += '<span class="mto-pl__price-label">' + priceLabel + '</span>';
        }
        priceEl.innerHTML = priceHTML;
      }

      // Quick add
      var quickAddContainer = clone.querySelector('.mto-pl__quick-add');
      if (quickAdd && variant && variant.available && quickAddContainer) {
        var btn = clone.querySelector('.mto-pl__quick-add-btn');
        if (btn) {
          btn.setAttribute('data-variant-id', variant.id);
          btn.textContent = addToCartText;
        }
      } else if (quickAddContainer) {
        quickAddContainer.remove();
      }

      if (card) {
        card.setAttribute('data-product-id', product.id);
        if (variant) card.setAttribute('data-variant-id', variant.id);
      }

      return clone;
    }

    /**
     * Ölçü rozeti + panelini doldurur (last_viewed kartları).
     * snippets/mto-size-options.liquid'in JS karşılığı — kurallar birebir aynı:
     *  • sıralama: fiyat artan, eşitse ölçü adı (Liquid'de sort:'title'→sort:'price')
     *  • "N ölçü" + aralık YALNIZ gerçek cm ölçülerinde; aksi halde "N seçenek"
     *  • tek varyant → rozet yok, düz metin
     */
    fillSizeOptions(clone, product, currencyCode) {
      var wrap = clone.querySelector('[data-mto-size]');
      if (!wrap) return;

      var variants = (product.variants || []).slice();
      var opt = this.pickSizeOption(product);
      if (!opt || !variants.length) {
        wrap.remove();
        return;
      }

      var single = wrap.querySelector('.mto-size__single');
      var badge = wrap.querySelector('.mto-size__badge');
      var panel = wrap.querySelector('.mto-size-panel');

      // ── Tek varyant: rozet yok, sakin metin
      if (variants.length === 1) {
        var only = variants[0].title;
        if (!only || only === 'Default Title') {
          wrap.remove();
          return;
        }
        if (badge) badge.remove();
        if (panel) panel.remove();
        if (single) {
          single.textContent = only;
          single.removeAttribute('hidden');
        }
        wrap.removeAttribute('hidden');
        return;
      }

      if (single) single.remove();
      if (!badge || !panel) {
        wrap.remove();
        return;
      }

      // ── Sıralama: fiyat artan, eşit fiyatta ölçü adı
      variants.sort(function (a, b) {
        if (a.price !== b.price) return a.price - b.price;
        return a.title < b.title ? -1 : a.title > b.title ? 1 : 0;
      });

      var isRealSize = this.isRealSizeOption(product, opt);
      var word = isRealSize ? 'ölçü' : 'seçenek';
      var label = variants.length + ' ' + word;

      // ── Benzersiz popover id'si (aynı sayfada birden çok slider olabilir)
      var id = 'MtoSize-' + (this.dataset.sectionId || 'pl') + '-' + product.id;
      panel.id = id;
      badge.setAttribute('popovertarget', id);
      var closeBtn = panel.querySelector('.mto-size-panel__close');
      if (closeBtn) closeBtn.setAttribute('popovertarget', id);

      badge.setAttribute(
        'aria-label',
        product.title + ' — ' + label + ' seçeneğini fiyatlarıyla gör'
      );
      var countEl = badge.querySelector('.mto-size__count');
      if (countEl) countEl.textContent = label;

      var rangeEl = badge.querySelector('.mto-size__range');
      var range = isRealSize ? this.buildSizeRange(opt.values) : '';
      if (rangeEl) {
        if (range) {
          rangeEl.textContent = range;
          rangeEl.removeAttribute('hidden');
        } else {
          rangeEl.remove();
        }
      }

      var panelTitle = panel.querySelector('.mto-size-panel__title');
      if (panelTitle) panelTitle.textContent = product.title;
      var panelCount = panel.querySelector('.mto-size-panel__count');
      if (panelCount) panelCount.textContent = label;

      // ── Satırlar
      var list = panel.querySelector('.mto-size-panel__list');
      var soldOutText = this.dataset.soldOutText || 'Tükendi';
      var self = this;
      if (list) {
        variants.forEach(function (v) {
          var li = document.createElement('li');
          var row;
          if (v.available) {
            row = document.createElement('a');
            row.className = 'mto-size-panel__row';
            row.href = '/products/' + product.handle + '?variant=' + v.id;
          } else {
            row = document.createElement('span');
            row.className = 'mto-size-panel__row mto-size-panel__row--out';
          }
          var val = document.createElement('span');
          val.className = 'mto-size-panel__val';
          val.textContent = v.title;
          var price = document.createElement('span');
          price.className = 'mto-size-panel__price';
          price.textContent = v.available ? self.formatMoney(v.price, currencyCode) : soldOutText;
          row.appendChild(val);
          row.appendChild(price);
          li.appendChild(row);
          list.appendChild(li);
        });
      }

      badge.removeAttribute('hidden');
      wrap.removeAttribute('hidden');
    }

    /** Tema ayarındaki öncelik sırasına göre ilk eşleşen opsiyonu döndürür. */
    pickSizeOption(product) {
      var names = (this.dataset.sizeChipOptions || 'Ölçü,Miktar,Kalınlık,Ağırlık')
        .split(',')
        .map(function (x) { return x.trim().toLowerCase(); })
        .filter(Boolean);
      var opts = product.options || [];
      for (var i = 0; i < names.length; i++) {
        for (var j = 0; j < opts.length; j++) {
          var o = opts[j];
          var nm = typeof o === 'string' ? o : o.name || '';
          if (nm !== 'Title' && nm.toLowerCase() === names[i] && o.values && o.values.length) {
            return o;
          }
        }
      }
      return null;
    }

    /**
     * Değerler GERÇEKTEN cm ölçüsü mü? Tek opsiyon + adı "Ölçü" + tüm değerler
     * " cm" ile bitiyor + "/" (bileşik) yok. Opsiyon adı "Ölçü" ama değerleri
     * "500 Gram" olan ürünler var — onlara "ölçü" demek yanlış olurdu.
     */
    isRealSizeOption(product, opt) {
      var name = typeof opt === 'string' ? opt : opt.name || '';
      if (name !== 'Ölçü') return false;
      if ((product.options || []).length !== 1) return false;
      return (opt.values || []).every(function (v) {
        return v.indexOf('/') === -1 && v.indexOf(' cm') !== -1;
      });
    }

    /** "22×22 – 50×50 cm" — ilk boyuta göre SAYISAL min/max (alfabetik yanlış). */
    buildSizeRange(values) {
      if (!values || values.length < 2) return '';
      var min = null;
      var max = null;
      values.forEach(function (v) {
        var n = parseFloat(v);
        if (isNaN(n)) return;
        if (min === null || n < min.n) min = { n: n, v: v };
        if (max === null || n > max.n) max = { n: n, v: v };
      });
      if (!min || !max || min.v === max.v) return '';
      function short(v) {
        var parts = v.split('x');
        var a = parts[0].trim();
        if (parts.length >= 2) {
          return a + '×' + parts[1].split(' ')[0].trim();
        }
        return a.split(' ')[0];
      }
      return short(min.v) + ' – ' + short(max.v) + ' cm';
    }

    getDefaultVariant(product) {
      if (!product.variants || product.variants.length === 0) return null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) return product.variants[i];
      }
      return product.variants[0];
    }

    /**
     * Mağaza ayarındaki para biçimini uygular — Liquid'in `money` filtresiyle
     * AYNI çıktıyı verir.
     *
     * Eskiden Intl.NumberFormat kullanılıyordu ve "₺12,73" üretiyordu; temanın
     * her yeri (Liquid `money`) "12.73₺" diyor. Aynı sayfada iki farklı para
     * biçimi görünüyordu. Biçim şablonu artık data attribute ile Liquid'den
     * gelir (shop.money_format), JS yalnız placeholder'ları doldurur.
     * Desteklenen placeholder'lar Shopify'ın kendi setidir.
     */
    formatMoney(cents, withCode) {
      if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;

      var format = withCode
        ? this.dataset.moneyWithCurrencyFormat || this.dataset.moneyFormat
        : this.dataset.moneyFormat;

      if (!format) {
        // Biçim gelmediyse Intl'e düşmek yerine sade ve öngörülebilir kal.
        return (cents / 100).toFixed(2);
      }

      function group(num, thousands, decimal, decimals) {
        if (isNaN(num)) num = 0;
        var fixed = (num / 100).toFixed(decimals);
        var parts = fixed.split('.');
        var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + thousands);
        return decimals && parts[1] ? intPart + decimal + parts[1] : intPart;
      }

      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
        switch (name) {
          case 'amount':
            return group(cents, ',', '.', 2);
          case 'amount_no_decimals':
            return group(cents, ',', '.', 0);
          case 'amount_with_comma_separator':
            return group(cents, '.', ',', 2);
          case 'amount_no_decimals_with_comma_separator':
            return group(cents, '.', ',', 0);
          case 'amount_with_apostrophe_separator':
            return group(cents, "'", '.', 2);
          case 'amount_no_decimals_with_space_separator':
            return group(cents, ' ', ',', 0);
          case 'amount_with_space_separator':
            return group(cents, ' ', ',', 2);
          case 'amount_with_period_and_space_separator':
            return group(cents, ' ', '.', 2);
          default:
            return '';
        }
      });
    }

    /* ---- Ready: init carousel + hover ---- */
    onReady() {
      var pl = this.querySelector('.mto-pl');
      if (pl) pl.setAttribute('data-loaded', 'true');

      this.initCarousel();
      this.initHover();
      this.initQuickAdd();
      this.initVideoObserver();
    }

    /* ---- Carousel ---- */
    initCarousel() {
      this.track = this.querySelector('.mto-pl__track');
      this.navPrev = this.querySelector('.mto-pl__nav-btn--prev');
      this.navNext = this.querySelector('.mto-pl__nav-btn--next');

      if (!this.track || !this.track.classList.contains('mto-pl__track--carousel')) return;
      if (!this.navPrev || !this.navNext) return;

      var self = this;
      var scrollTimeout;

      this.navPrev.addEventListener('click', function () {
        self.scrollCarousel(-1);
      });

      this.navNext.addEventListener('click', function () {
        self.scrollCarousel(1);
      });

      this.track.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          self.updateNavState();
        }, 80);
      }, { passive: true });

      this.updateNavState();
    }

    scrollCarousel(direction) {
      if (!this.track) return;
      var cards = this.track.querySelectorAll('.mto-pl__card');
      if (cards.length === 0) return;
      var cardWidth = cards[0].offsetWidth;
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
    }

    updateNavState() {
      if (!this.track || !this.navPrev || !this.navNext) return;
      var sl = this.track.scrollLeft;
      var maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.navPrev.disabled = sl <= 2;
      this.navNext.disabled = sl >= maxScroll - 2;
    }

    /* ---- Hover (second image / video) ---- */
    initHover() {
      var cards = this.querySelectorAll('.mto-pl__card');
      cards.forEach(function (card) {
        var video = card.querySelector('video.mto-pl__media-hover');
        if (!video) return;

        card.addEventListener('pointerenter', function () {
          // Load video sources on first hover
          var sources = video.querySelectorAll('source[data-src]');
          if (sources.length > 0) {
            sources.forEach(function (s) {
              s.src = s.getAttribute('data-src');
              s.removeAttribute('data-src');
            });
            video.load();
          }
          var playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(function () { /* autoplay blocked, ignore */ });
          }
        });

        card.addEventListener('pointerleave', function () {
          video.pause();
          video.currentTime = 0;
        });
      });
    }

    /* ---- Video IntersectionObserver for mobile carousel ---- */
    initVideoObserver() {
      var videos = this.querySelectorAll('video.mto-pl__media-hover');
      if (videos.length === 0) return;
      if (!('IntersectionObserver' in window)) return;

      // Only use observer on touch/coarse pointer devices
      var isTouch = window.matchMedia('(pointer: coarse)').matches;
      if (!isTouch) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            var card = video.closest('.mto-pl__card');
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
              // Load sources
              var sources = video.querySelectorAll('source[data-src]');
              sources.forEach(function (s) {
                s.src = s.getAttribute('data-src');
                s.removeAttribute('data-src');
              });
              if (sources.length > 0) video.load();
              var p = video.play();
              if (p) p.catch(function () {});
              if (card) card.classList.add('mto-pl__card--touch-active');
            } else {
              video.pause();
              if (card) card.classList.remove('mto-pl__card--touch-active');
            }
          });
        },
        { threshold: [0, 0.6] }
      );

      videos.forEach(function (v) { observer.observe(v); });
    }

    /* ---- Quick Add ---- */
    initQuickAdd() {
      var self = this;
      this.querySelectorAll('.mto-pl__quick-add-btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var variantId = btn.getAttribute('data-variant-id');
          if (!variantId) return;
          self.addToCart(btn, variantId);
        });
      });
    }

    addToCart(btn, variantId) {
      if (btn.classList.contains('mto-pl__quick-add-btn--loading')) return;
      btn.classList.add('mto-pl__quick-add-btn--loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function () {
          btn.classList.remove('mto-pl__quick-add-btn--loading');
          // Fetch updated cart and publish via Dawn's pub/sub
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cartData) {
          if (!cartData) return;
          // Dawn pub/sub integration
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'mto-product-list',
              cartData: cartData,
              variantId: variantId
            });
          }
          // Update cart count bubbles
          var bubbles = document.querySelectorAll('.cart-count-bubble span');
          bubbles.forEach(function (b) { b.textContent = cartData.item_count; });
          // Show bubble if hidden
          var bubble = document.querySelector('.cart-count-bubble');
          if (bubble) bubble.classList.remove('visually-hidden');
        })
        .catch(function () {
          btn.classList.remove('mto-pl__quick-add-btn--loading');
        });
    }

    resizeImage(url, width) {
      if (!url) return url;
      // Ensure protocol
      if (url.startsWith('//')) url = 'https:' + url;
      // Shopify CDN: append or replace width param
      try {
        var u = new URL(url);
        u.searchParams.set('width', width);
        return u.toString();
      } catch (e) {
        // Fallback: append width param manually
        var sep = url.indexOf('?') > -1 ? '&' : '?';
        return url + sep + 'width=' + width;
      }
    }

    hideSection() {
      this.closest('.shopify-section').style.display = 'none';
    }
  }

  customElements.define('mto-product-list', MtoProductList);
}
